import { useEffect, useMemo, useState } from "react";
import { isValidArray, isValidObject } from "../../Services/validators";
import Button from "../Button/Button";
import { SelectionCard, SelectionRadioCard } from "../Cards/Cards";
import InputBox from "../InputBox/InputBox";
import PreviewBar from "../PreviewBar/PreviewBar";
// import ProfilePicture from "../ProfilePicture/ProfilePicture";
import { capitalizeFirstLetter, Regex } from "../../Utils/Constants/Constants";
import CropperModal from "../CropperModal/CropperModal";
import CustomSelect from "../CustomSelect/CustomSelect";
import Modal from "../Modal/Modal";

function CreateWorkforce(props) {
  const [step, setStep] = useState("selection");
  const [file, setFile] = useState({ image: null });
  const [croppedImage, setCroppedImage] = useState(null);
  const [formData, setFormData] = useState({
    type: "",
    name: "",
    employeeId: "",
    phoneNumber: "+91",
    email: "",
    roles: []
  });

  const [isFaceDetected, setIsFaceDetected] = useState(null);

  const isValidEmployeeId = (employeeId = formData.employeeId) => {
    if (employeeId.length === 0) {
      return { status: true };
    }

    if (employeeId.length > 2) {
      if (props.workforceData[employeeId]) {
        return {
          status: false,
          message: `${capitalizeFirstLetter(formData.type)} Id already exists`
        };
      } else {
        return {
          status: true
        };
      }
    } else {
      return {
        status: false,
        message: `Please enter valid ${capitalizeFirstLetter(formData.type)} Id`
      };
    }
  };

  const isValidPhoneNumber = (phoneNumber = formData.phoneNumber) => {
    if (
      phoneNumber === "+91" ||
      phoneNumber === "" ||
      (phoneNumber.length === 13 && !isNaN(phoneNumber))
    ) {
      if (
        Object.values(props.workforceData).find(
          (data) => data.phoneNumber === phoneNumber
        )
      ) {
        return {
          status: false,
          message: "Phone number already exists"
        };
      } else {
        return {
          status: true
          // message: "Please enter valid phone numberr"
        };
      }
    } else {
      return {
        status: false,
        message: "Please enter valid phone number"
      };
    }
  };

  const isValidEmail = (email = formData.email) => {
    if (Regex.email.test(email)) {
      if (
        Object.values(props.workforceData).find((data) => data.email === email)
      ) {
        return {
          status: false,
          message: "Email already exists"
        };
      } else {
        return {
          status: true
          // message: "Please enter valid phone numberr"
        };
      }
    } else {
      return {
        status: false,
        message: "Please enter valid Email"
      };
    }
  };

  const handleDisable = useMemo(() => {
    if (isFaceDetected === false) {
      return true;
    }
    const requiredFields = [
      formData.name,
      formData.type ? isValidPhoneNumber()?.status : isValidEmail()?.status,
      formData.type,
      formData.roles.length > 0,
      formData.employeeId ? isValidEmployeeId()?.status : false
    ];

    return requiredFields.some((field) => !field) ? true : false;
    // eslint-disable-next-line
  }, [formData, isFaceDetected]);

  useEffect(() => {
    if (isValidArray(formData.roles)) {
      setFormData({ ...formData, roles: [] });
    }
    // eslint-disable-next-line
  }, [formData.type]);

  const getValidRoles = () => {
    if (isValidObject(props.roles)) {
      const roles = { ...props.roles };
      return Object.values(roles)
        .filter((role) => isValidObject(role.attendance?.capture))
        .map((role) => role.documentId);
    }
  };

  return (
    <>
      <PreviewBar
        title="New Employee"
        onCloseClick={() => {
          props.navigate("/workforce");
        }}
      >
        <div className="inherit-parent-height">
          {step === "selection" && (
            <div className="inherit-parent-height">
              <TypeSelection
                setFormData={setFormData}
                formData={formData}
                continueClick={() => {
                  setStep("creation");
                }}
              />
            </div>
          )}

          {step === "creation" && (
            <div className="inherit-parent-height display-flex flex-justify-content-space-between flex-direction-column overflow-hidden">
              <div
                style={{
                  height: "calc(100% - 56px)"
                }}
                className="overflow-scroll"
              >
                <div className="padding-bottom-large  font-color-tertiaryColor6">
                  BASIC INFORMATION
                </div>
                <SelectionCard
                  title="TYPE"
                  value={formData.type}
                  changeOnClick={() => {
                    setStep("selection");
                  }}
                />

                <BasicInfoForm
                  roles={props.roles}
                  validRoles={getValidRoles()}
                  formData={formData}
                  setFormData={setFormData}
                  setFile={setFile}
                  type="add"
                  imageSrc={
                    croppedImage ? URL.createObjectURL(croppedImage) : null
                  }
                  isFaceDetected={isFaceDetected}
                  setIsFaceDetected={setIsFaceDetected}
                  setErrorStatus={props.setErrorStatus}
                  // workforceData={props.workforceData}
                  isValidEmployeeId={isValidEmployeeId}
                  isValidPhoneNumber={isValidPhoneNumber}
                  isValidEmail={isValidEmail}
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      [event.target.name]:
                        event.target.name === "employeeId"
                          ? event.target.value.toUpperCase()
                          : event.target.value
                    });
                  }}
                />
              </div>

              <div
                style={{ bottom: 0, zIndex: 1 }}
                className="padding-top-larger"
              >
                <Button
                  type="button"
                  disabled={handleDisable}
                  text="Create new employee"
                  loading={props.createNewEmployeeLoading}
                  onClick={() => {
                    const data = {
                      type: formData.type,
                      name: formData.name,
                      employeeId: formData.employeeId,
                      ...(formData.type === "employee"
                        ? { phoneNumber: formData.phoneNumber }
                        : {}),
                      ...(formData.type === "admin"
                        ? { email: formData.email }
                        : {}),
                      roles: formData.roles,
                      captureStatus: {
                        lastCapturedAt: 0
                      }
                    };
                    props.createNewEmployee(data, croppedImage);
                    setFormData({
                      type: formData.type,
                      name: "",
                      employeeId: "",
                      phoneNumber: "+91",
                      email: "",
                      roles: []
                    });
                  }}
                  data-cy="CREATE-WORKFORCE-CONFIRM-BUTTON"
                />
              </div>
            </div>
          )}
        </div>
      </PreviewBar>
      <Modal
        show={file?.image?.name ? true : false}
        canIgnore={true}
        onClose={() => {
          setFile({ image: null });
        }}
        width="width-60-percentage"
        maxWidth="max-width-800px"
        maxHeight="max-height-80-percentage"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="height-80-percentage"
      >
        <div
          data-cy="cropper-modal"
          className={`font-family-gilroy-regular font-color-tertiaryColor6 background-color-tertiaryColor1`}
        >
          <CropperModal
            className="border-radius-default"
            OnBlobCreate={(blob) => {
              const imageFile = new File([blob], `${+new Date()}.png`, {
                type: "image/png"
              });
              setCroppedImage(imageFile);
            }}
            file={file?.image?.name ? URL.createObjectURL(file.image) : null}
            setFile={() => {
              setFile({ image: null });
            }}
          />
        </div>
      </Modal>
    </>
  );
}

export default CreateWorkforce;

const TypeSelection = (props) => {
  const data = [
    {
      title: "Employee",
      description: "Field operatives for execution of objectives"
    },
    {
      title: "Admin",
      description: "Executive and Management Personnel to oversee operations"
    }
  ];

  return (
    <div className="display-flex flex-direction-column flex-justify-content-space-between inherit-parent-height">
      <div>
        <div className="padding-bottom-large font-color-tertiaryColor6">
          TYPE
        </div>
        {data.map((data, i) => (
          <div
            key={i}
            onClick={() => {
              props.setFormData({
                ...props.formData,
                type: data.title.toLocaleLowerCase()
              });
            }}
            className="padding-bottom-large"
          >
            <SelectionRadioCard
              data={data}
              selected={props.formData.type === data.title.toLocaleLowerCase()}
            />
          </div>
        ))}
      </div>
      <div>
        <Button
          type="button"
          data-cy="TYPE-CONFIRM-BUTTON"
          disabled={props.formData.type ? false : true}
          text="Continue"
          onClick={props.continueClick}
        />
      </div>
    </div>
  );
};

const BasicInfoForm = (props) => {
  const getOptions = useMemo(() => {
    if (!isValidObject(props.roles)) {
      return;
    }
    const hasValidRole = props.formData.roles.some((role) =>
      props.validRoles.includes(role)
    );

    const allRoles = Object.values(props.roles).filter(
      (data) => data.type === props.formData.type
    );

    const selectedRoles = allRoles.filter((data) =>
      props.formData.roles.includes(data.documentId)
    );

    const filteredRoles = [
      ...new Map(
        [
          ...allRoles.filter(
            (data) => !hasValidRole || !isValidObject(data.attendance?.capture)
          ),
          ...selectedRoles
        ].map((item) => [item.documentId, item])
      ).values()
    ];

    const filteredKeys = new Set(filteredRoles.map((data) => data.documentId));

    const options = allRoles.map((data) => ({
      title: data.name,
      key: data.documentId,
      disabled: !filteredKeys.has(data.documentId)
    }));

    return options;
  }, [
    props.formData.roles,
    props.validRoles,
    props.roles,
    props.formData.type
  ]);

  return (
    <>
      <form onChange={props.onChange} className="padding-top-large">
        <InputBox
          className="inherit-parent-width"
          name="name"
          label="NAME*"
          type="text"
          placeholder={`Enter ${capitalizeFirstLetter(
            props.formData.type
          )} Name`}
          removeResponsive={true}
          value={props.formData.name}
          fontColor="font-color-tertiaryColor"
          labelFontColor="font-color-tertiaryColor"
          data-cy="NAME-FIELD"
          required
        />
        <InputBox
          className="inherit-parent-width"
          name="employeeId"
          label={`${props.formData.type.toUpperCase()} ID*`}
          type="text"
          placeholder={`Enter ${capitalizeFirstLetter(props.formData.type)} Id`}
          removeResponsive={true}
          value={props.formData.employeeId}
          fontColor="font-color-tertiaryColor"
          labelFontColor="font-color-tertiaryColor"
          data-cy="ID-FIELD"
          required
          validation={(value) => {
              return props.isValidEmployeeId();
            }}
        />
        {props.formData.type === "employee" && (
          <InputBox
            className="inherit-parent-width"
            name="phoneNumber"
            label="PHONE NUMBER*"
            type="text"
            placeholder={`Enter ${capitalizeFirstLetter(
              props.formData.type
            )} Phone Number`}
            removeResponsive={true}
            value={props.formData.phoneNumber}
            fontColor="font-color-tertiaryColor"
            labelFontColor="font-color-tertiaryColor"
            data-cy="PHONE-NUMBER-FIELD"
            required
            validation={(value) => {
              return props.isValidPhoneNumber();
            }}
          />
        )}
        {props.formData.type === "admin" && (
          <InputBox
            className="inherit-parent-width"
            name="email"
            label="EMAIL*"
            type="text"
            placeholder={`Enter ${capitalizeFirstLetter(
              props.formData.type
            )} EMAIL`}
            removeResponsive={true}
            value={props.formData.email}
            fontColor="font-color-tertiaryColor"
            labelFontColor="font-color-tertiaryColor"
            data-cy="EMAIL-FIELD"
            required
            validation={(value) => {
              return props.isValidEmail();
            }}
          />
        )}
      </form>
      {/* <div className="padding-bottom-default font-size-smaller font-color-tertiaryColor">
        PROFILE
      </div>
      <ProfilePicture
        isOpen={true}
        name={props.formData.name}
        setFile={props.setFile}
        setErrorStatus={props.setErrorStatus}
        imageSrc={props.imageSrc}
        type={props.type}
        isFaceDetected={props.isFaceDetected}
        setIsFaceDetected={props.setIsFaceDetected}
      /> */}
      {isValidObject(props.roles) && (
        <div className="inherit-parent-width padding-top-large">
          <CustomSelect
            data-cy="ROLES-SELECT-FILTER"
            options={getOptions}
            search={true}
            placeholder="SELECT ONE OR MORE ROLES"
            handleSelectedData={(data) => {
              if (props.formData.roles.includes(data)) {
                props.setFormData({
                  ...props.formData,
                  roles: props.formData.roles.filter((e) => e !== data)
                });
              } else {
                props.setFormData({
                  ...props.formData,
                  roles: [...props.formData.roles, data]
                });
              }
            }}
            selected={props.formData.roles}
            removeResponsive={true}
            label={`ROLES (${props.formData.roles.length})`}
            value={getRolesNameUsingId(props.formData.roles, props.roles).join(
              ", "
            )}
            fontColor="font-color-tertiaryColor"
            labelFontColor="font-color-tertiaryColor"
          />
        </div>
      )}
    </>
  );
};

const getRolesNameUsingId = (selectedData, allData) => {
  let updatedData = [];
  selectedData.forEach((element) => {
    updatedData.push(allData[element].name);
  });
  return updatedData;
};
